<div
    class="headers"
    [ngClass]="{ 'headers__logged-in': (isAuth$ | async), reducedMenu: (isMenuOpen$ | async) === false }"
>
    <app-header-logged-in *ngIf="(isAuth$ | async) && (dashboardSelected$ | async)" [ngClass]=""></app-header-logged-in>
    <app-header-logged-out *ngIf="(isAuth$ | async) === false || (dashboardSelected$ | async) === false"></app-header-logged-out>
</div>
